"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineApiCommandsNeeded = exports.isVPNFraudCheckRequired = exports.redefineRequestItems = exports.getDefaultResponse = exports.fetchVpnFraudItem = exports.fetchRedefinedItems = exports.getPricePlanResponse = exports.isPricePlanRequest = exports.getResponseWithPricingData = exports.getNextInteraction_bff = void 0;
var tslib_1 = require("tslib");
/* eslint-disable  @typescript-eslint/camelcase */
var interfaces_1 = require("../interfaces");
var index_1 = require("../index");
var index_2 = require("../../common/index");
var interfaces_2 = require("../../common/interfaces");
var interfaces_3 = require("../../pricingApi/interfaces");
var pricingApi_1 = tslib_1.__importDefault(require("../../pricingApi"));
function getNextInteraction_bff(input, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {
        timeout: interfaces_1.PRICING_TIMEOUT,
    }; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var internalRequestPayload, vpnCheckRequired;
        return tslib_1.__generator(this, function (_a) {
            internalRequestPayload = input.internalRequestPayload;
            delete input.internalRequestPayload;
            vpnCheckRequired = isVPNFraudCheckRequired(input);
            if (isPricePlanRequest(input)) {
                // price plan request then figure out nextInteraction payload
                return [2 /*return*/, getPricePlanResponse(input, requestOptions, { vpnCheckRequired: vpnCheckRequired })];
            }
            else {
                // getDefault response
                return [2 /*return*/, getDefaultResponse(input, requestOptions, {
                        vpnCheckRequired: vpnCheckRequired,
                        internalRequestPayload: internalRequestPayload,
                    })];
            }
            return [2 /*return*/];
        });
    });
}
exports.getNextInteraction_bff = getNextInteraction_bff;
/**
 * getNoneOperationResponse: in case None operation is returned by pricing-sdk request determination logic. Call this function to build next interaction response payload
 * @param input
 * @param internalState
 * @returns GetNextInteractionResponse
 */
function getNoneOperationResponse(input, internalState) {
    var nextInteractionRequest = internalState.nextInteractionRequest, userGeolocation = internalState.userGeolocation, authorizeParams = internalState.authorizeParams;
    var nextInteractionData = nextInteractionCommand(nextInteractionRequest, {}).data;
    var finalActions = nextInteractionRequest.finalActions;
    var isError = nextInteractionData.interaction == interfaces_2.Interactions.ERROR.toString();
    return (0, index_1.createNextInteractionPayload)({
        data: isError
            ? null
            : tslib_1.__assign(tslib_1.__assign({}, nextInteractionData), { action: (finalActions && finalActions.length && finalActions[0]) || "", uuid: input.pricingData.authState.uuid, loginState: input.pricingData.authState.state }),
        errors: null,
        success: !isError,
    }, tslib_1.__assign(tslib_1.__assign({}, input), { authorizeParams: authorizeParams, userGeolocation: userGeolocation }));
}
/**
 * getResponseWithPricingData
 */
function getResponseWithPricingData(input, nextInteractionRequest, _a) {
    var products = _a.products, authorizeParams = _a.authorizeParams, userGeolocation = _a.userGeolocation, apiResponse = _a.apiResponse;
    var nextInteractionData = nextInteractionCommand(nextInteractionRequest, apiResponse).data;
    input.pricingData = apiResponse.data;
    var _b = input.pricingData || {}, eligibility = _b.eligibility, authState = _b.authState;
    var annotation = (eligibility || {}).annotation;
    var nextInteractionResponse = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, authState), { action: "" }), nextInteractionData);
    products = (products === null || products === void 0 ? void 0 : products.length) ? products : [input.pricingData];
    return (0, index_1.createNextInteractionPayload)({ data: nextInteractionResponse, errors: null }, tslib_1.__assign(tslib_1.__assign({}, input), { itemAnnotations: annotation || {}, authorizeParams: authorizeParams, userGeolocation: userGeolocation, products: products }));
}
exports.getResponseWithPricingData = getResponseWithPricingData;
/**
 * isPricePlanRequest: determine if finalAction is checkout operation and pricePlanSelection is set
 * @param input
 * @returns
 */
function isPricePlanRequest(input) {
    var finalAction = input.finalAction, pricePlanSelection = input.pricePlanSelection, eligibilityFinalActions = input.pricingData.eligibility.finalActions;
    var finalActions = (finalAction && [finalAction]) || eligibilityFinalActions || [];
    return !!(pricePlanSelection &&
        [
            interfaces_3.IntendedActions.JOIN.toString(),
            interfaces_3.IntendedActions.RESUBSCRIBE.toString(),
            interfaces_3.IntendedActions.DOWNGRADE.toString(),
            interfaces_3.IntendedActions.UPGRADE.toString(),
        ].filter(function (actionName) { return finalActions.includes(actionName); }).length > 0);
}
exports.isPricePlanRequest = isPricePlanRequest;
/**
 * isPricePlanRequest: determine if finalAction is checkout operation and pricePlanSelection is set
 * @param input
 * @returns
 */
function getPricePlanResponse(input, requestOptions, _a) {
    var vpnCheckRequired = _a.vpnCheckRequired;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var result, _b, operationName, request, nextInteractionRequest, userGeolocation, authorizeParams, data, success, errors;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = determineGetPricingByExternalIdRequest(input), operationName = _b.operationName, request = _b.request, nextInteractionRequest = _b.nextInteractionRequest, userGeolocation = _b.userGeolocation, authorizeParams = _b.authorizeParams;
                    if (operationName == interfaces_2.GraphQLOperations.NONE) {
                        // if request is none then build none operation response
                        return [2 /*return*/, Promise.resolve(getNoneOperationResponse(input, {
                                nextInteractionRequest: nextInteractionRequest,
                                userGeolocation: userGeolocation,
                                authorizeParams: authorizeParams,
                            }))];
                    }
                    // call getPricingByExternalId to get GetPricingV2Response for selection price plan
                    request.dataRequested = vpnCheckRequired
                        ? "".concat(request.dataRequested, ",vpnCheck")
                        : request.dataRequested;
                    return [4 /*yield*/, pricingApi_1.default.getPricingByExternalId(request, requestOptions)];
                case 1:
                    result = _c.sent();
                    data = result.data, success = result.success, errors = result.errors;
                    if (success && data) {
                        // Success then build nextInteraction payload
                        return [2 /*return*/, getResponseWithPricingData(input, nextInteractionRequest, {
                                authorizeParams: authorizeParams,
                                userGeolocation: userGeolocation,
                                apiResponse: result,
                            })];
                    }
                    return [2 /*return*/, { success: success, errors: errors, data: null }];
            }
        });
    });
}
exports.getPricePlanResponse = getPricePlanResponse;
/**
 * fetchRedefinedItems: fetch cspOnly item details from servers by calling getPricingV2
 * @param input
 * @param requestOptions
 * @param param2
 * @returns
 */
function fetchRedefinedItems(input, requestOptions, _a) {
    var redefineItems = _a.redefineItems, billing = _a.billing;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var redfinedProducts, redfinedItemsResponse, redefinedPricingV2Data, currentProductFamily_1, currentProduct, products;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all(redefineItems.map(function (pricingV2Request) {
                        return pricingApi_1.default.getPricingV2(tslib_1.__assign(tslib_1.__assign({}, pricingV2Request), { billing: billing }), requestOptions);
                    }))];
                case 1:
                    redfinedItemsResponse = _b.sent();
                    redefinedPricingV2Data = redfinedItemsResponse.map(function (_a) {
                        var success = _a.success, data = _a.data;
                        return success ? data : null;
                    });
                    if (redefinedPricingV2Data.length ==
                        redefinedPricingV2Data.filter(function (pricingV2Data) { return pricingV2Data != null; })
                            .length) {
                        redfinedProducts = redefinedPricingV2Data;
                        currentProductFamily_1 = input.pricingData.productFamily;
                        currentProduct = redfinedProducts.filter(function (_a) {
                            var redefinedItemProductFamily = _a.productFamily;
                            return redefinedItemProductFamily.toString() ===
                                currentProductFamily_1.toString();
                        });
                        if (currentProduct.length) {
                            input.pricingData = currentProduct[0];
                        }
                        products = redfinedProducts.filter(function (_a) {
                            var _b, _c, _d;
                            var eligibility = _a.eligibility;
                            return eligibility.eligible &&
                                ((_d = (_c = (_b = eligibility.pricePlans) === null || _b === void 0 ? void 0 : _b.quoteItems) === null || _c === void 0 ? void 0 : _c.priceQuoteItems) === null || _d === void 0 ? void 0 : _d.length);
                        });
                        return [2 /*return*/, products];
                    }
                    return [2 /*return*/, Promise.resolve([])];
            }
        });
    });
}
exports.fetchRedefinedItems = fetchRedefinedItems;
/**
 * fetchVpnFraudItem: fetch vpnFraudItem and build next interaction 1click payload
 * @param input
 * @param requestOptions
 * @param param2
 * @returns
 */
function fetchVpnFraudItem(input, requestOptions, _a) {
    var nextInteractionRequest = _a.nextInteractionRequest, authorizeParams = _a.authorizeParams, userGeolocation = _a.userGeolocation, billing = _a.billing;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _b, productFamily, offerId, countryCode, pricingV2Request, result, success, errors, data;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = input.pricingData, productFamily = _b.productFamily, offerId = _b.offerId, countryCode = _b.countryCode;
                    pricingV2Request = {
                        countryCode: countryCode,
                        dataRequested: interfaces_3.Commands.ELIGIBILITY_WITH_TAX_FRAUD,
                        productCode: productFamily,
                        offerId: offerId,
                        billing: billing,
                    };
                    return [4 /*yield*/, pricingApi_1.default.getPricingV2(pricingV2Request, requestOptions)];
                case 1:
                    result = _c.sent();
                    success = result.success, errors = result.errors, data = result.data;
                    if (success && data) {
                        return [2 /*return*/, getResponseWithPricingData(input, nextInteractionRequest, {
                                authorizeParams: authorizeParams,
                                userGeolocation: userGeolocation,
                                apiResponse: result,
                            })];
                    }
                    input.pricingData.networkInfo = { isAnonymous: false };
                    return [2 /*return*/, { success: success, errors: errors, data: null }];
            }
        });
    });
}
exports.fetchVpnFraudItem = fetchVpnFraudItem;
/**
 * getDefaultResponse: This has cspOnly, vpnCheck and default nextInteraction use cases
 * @param input
 * @param requestOptions
 * @param param2
 * @returns
 */
function getDefaultResponse(input, requestOptions, _a) {
    var _b;
    var vpnCheckRequired = _a.vpnCheckRequired, internalRequestPayload = _a.internalRequestPayload;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var result, _c, operationName, request, nextInteractionRequest, userGeolocation, authorizeParams, redefineItems, billing, products, nextInteractionData;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _c = determineNextInteractionRequest(input), operationName = _c.operationName, request = _c.request, nextInteractionRequest = _c.nextInteractionRequest, userGeolocation = _c.userGeolocation, authorizeParams = _c.authorizeParams;
                    redefineItems = redefineRequestItems(input);
                    billing = ((_b = request === null || request === void 0 ? void 0 : request.input) === null || _b === void 0 ? void 0 : _b.billing) || {
                        country: userGeolocation.countryCode,
                    };
                    if (!(redefineItems === null || redefineItems === void 0 ? void 0 : redefineItems.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchRedefinedItems(input, requestOptions, {
                            billing: billing,
                            redefineItems: redefineItems,
                        })];
                case 1:
                    products = _d.sent();
                    // if products fetched successfully and products list is not empty do csponly path
                    if (products.length) {
                        // return cspOnly nextInteraction paylaod
                        return [2 /*return*/, getResponseWithPricingData(input, nextInteractionRequest, {
                                authorizeParams: authorizeParams,
                                userGeolocation: userGeolocation,
                                apiResponse: {
                                    data: input.pricingData,
                                    success: true,
                                },
                                products: products,
                            })];
                    }
                    return [3 /*break*/, 4];
                case 2:
                    if (!vpnCheckRequired) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchVpnFraudItem(input, requestOptions, {
                            billing: billing,
                            authorizeParams: authorizeParams,
                            userGeolocation: userGeolocation,
                            nextInteractionRequest: nextInteractionRequest,
                        })];
                case 3:
                    // if vpnCheckRequired flag is there then fetch itemDetails with vpnCheck on
                    result = _d.sent();
                    // if vpn fraud item response is successful then return nextInteraction payload
                    if (result.success && result.data) {
                        return [2 /*return*/, result];
                    }
                    _d.label = 4;
                case 4:
                    // In case of default use case and operationName is none then return none operation 1click payload response
                    /* istanbul ignore next */
                    if (operationName == interfaces_2.GraphQLOperations.NONE) {
                        // if request is none then build none operation response
                        return [2 /*return*/, Promise.resolve(getNoneOperationResponse(input, {
                                nextInteractionRequest: nextInteractionRequest,
                                userGeolocation: userGeolocation,
                                authorizeParams: authorizeParams,
                            }))];
                    }
                    return [4 /*yield*/, (0, index_2.sendBFFCall)(operationName, request, nextInteractionRequestDataTransformer, undefined, requestOptions.timeout, internalRequestPayload).catch(function (error) { return JSON.parse(error.message); })];
                case 5:
                    // call bff nextInteraction
                    result = _d.sent(); // make nextInteracation request call to bff
                    // if bff nextInteraction is successful
                    if (result.success) {
                        nextInteractionData = nextInteractionCommand(nextInteractionRequest, result).data;
                        result.data = tslib_1.__assign(tslib_1.__assign({}, result.data), nextInteractionData);
                        // return next interaction payload
                        return [2 /*return*/, (0, index_1.createNextInteractionPayload)(result, tslib_1.__assign(tslib_1.__assign({}, input), { authorizeParams: authorizeParams, userGeolocation: userGeolocation, products: [input.pricingData] }))]; // build next interaction payload
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
exports.getDefaultResponse = getDefaultResponse;
/**
 * redefineRequestItems: check if cspOnly needs to be triggered and prepare getPricingV2 request for items
 * @param input
 * @param products
 * @param actions
 * @param productsToOffer
 * @returns
 */
function redefineRequestItems(input, products, actions, productsToOffer) {
    if (products === void 0) { products = [
        interfaces_2.ProductType.CHEGG_STUDY,
        interfaces_2.ProductType.CHEGG_STUDY_PACK,
    ]; }
    if (actions === void 0) { actions = [interfaces_3.IntendedActions.RESUBSCRIBE]; }
    if (productsToOffer === void 0) { productsToOffer = [
        {
            productCode: interfaces_2.ProductType.CHEGG_STUDY_PACK,
            offerId: ["CS_SUB", "EB_SUB", "MATH_SUB"],
        },
    ]; }
    var offerIdMap = {
        CHEGG_STUDY: ["CS_SUB_V2"],
        BUNDLE: ["CS_SUB", "EB_SUB", "MATH_SUB"],
    };
    var _a = input.pricingData, productFamily = _a.productFamily, offerId = _a.offerId, countryCode = _a.countryCode, finalActions = _a.eligibility.finalActions, networkInfo = _a.networkInfo;
    var supportedActions = (finalActions === null || finalActions === void 0 ? void 0 : finalActions.filter(function (actionName) {
        return actions
            .map(function (intendedAction) { return intendedAction.toString(); })
            .includes(actionName);
    })) || [];
    // product matches, action matches, pageContext is not empty, country is US
    if (products
        .map(function (productType) { return productType.toString(); })
        .includes(productFamily.toString()) &&
        supportedActions.length > 0 &&
        (countryCode.toUpperCase() === "US" || (networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.isAnonymous))) {
        var pageContext = "".concat(productFamily
            .toString()
            .toLowerCase(), "-").concat(supportedActions[0].toLowerCase());
        var priceRequestParams_1 = {
            pricePlanInput: { pageContext: pageContext },
            countryCode: countryCode,
            dataRequested: interfaces_3.Commands.ELIGIBILITY_WITH_TAX_FRAUD,
        };
        var originalProduct_1 = {
            productCode: productFamily,
            offerId: (offerId === null || offerId === void 0 ? void 0 : offerId.length) ? offerId : offerIdMap[productFamily.toString()],
        };
        // if original product is not part of productsToOffer then add original product to list
        if (productsToOffer.filter(function (_a) {
            var productCode = _a.productCode;
            return productCode.toString() == originalProduct_1.productCode.toString();
        }).length === 0) {
            productsToOffer.push(originalProduct_1);
        }
        // return items request data
        return productsToOffer.map(function (productToOffer) { return (tslib_1.__assign(tslib_1.__assign({}, priceRequestParams_1), productToOffer)); });
    }
    // return undefined in case of cspOnly condition does not match
    return undefined;
}
exports.redefineRequestItems = redefineRequestItems;
/**
 * isVPNFraudCheckRequired: Determine VPN check is required for this request
 * match productType/productFamily/productCode, is checkout operation, country is not US
 * @param input
 * @param filters
 * @returns
 */
function isVPNFraudCheckRequired(input, products) {
    if (products === void 0) { products = [
        interfaces_2.ProductType.CHEGG_STUDY,
        interfaces_2.ProductType.CHEGG_STUDY_PACK,
    ]; }
    var _a = input.pricingData, networkInfo = _a.networkInfo, productFamily = _a.productFamily, countryCode = _a.countryCode, finalActions = _a.eligibility.finalActions;
    // match productType/productFamily/productCode, is checkout operation, country is not US
    if ((networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.isAnonymous) &&
        products
            .map(function (productType) { return productType.toString(); })
            .includes(productFamily.toString()) &&
        isOrderPlacement(finalActions || []) &&
        countryCode.toUpperCase() !== "US") {
        return true;
    }
    return false;
}
exports.isVPNFraudCheckRequired = isVPNFraudCheckRequired;
/**
 * determineGetPricingByExternalIdRequest: Determine pricePlan condition and build getPricingByExternalId request payload
 * @param input
 * @returns
 */
function determineGetPricingByExternalIdRequest(input) {
    var _a, _b;
    var operationName = interfaces_2.GraphQLOperations.NONE;
    var finalAction = input.finalAction, pricePlanSelection = input.pricePlanSelection;
    var productId = (pricePlanSelection || {}).externalId;
    var userGeolocation = input.userGeolocation, authorizeParams = input.authorizeParams, _c = input.pricingData, productCode = _c.productFamily, countryCode = _c.countryCode, _d = _c.eligibility, finalActions = _d.finalActions, pricePlans = _d.pricePlans;
    var selectedPlan = (_b = (_a = pricePlans === null || pricePlans === void 0 ? void 0 : pricePlans.quoteItems) === null || _a === void 0 ? void 0 : _a.priceQuoteItems) === null || _b === void 0 ? void 0 : _b.filter(function (_a) {
        var externalId = _a.itemDetails.externalId;
        if (externalId === productId)
            return true;
        return false;
    }).pop();
    var _e = selectedPlan || { itemDetails: {}, pricingKey: {} }, itemId = _e.itemDetails.externalId, experiment = _e.pricingKey.experimentId;
    if (itemId) {
        operationName = interfaces_2.GraphQLOperations.GET_PRICING_BY_EXTERNALID;
    }
    var taxAddress = getTaxAddress(input);
    return {
        operationName: operationName,
        request: {
            itemId: itemId,
            experiment: experiment,
            productCode: productCode,
            countryCode: countryCode,
            dataRequested: "eligibility,tax",
            IntendedActions: [finalAction],
            billing: taxAddress,
        },
        userGeolocation: userGeolocation || {
            countryCode: taxAddress.country,
        },
        nextInteractionRequest: tslib_1.__assign({}, (operationName !== interfaces_2.GraphQLOperations.NONE
            ? { interactions: input.interactions, finalActions: finalActions }
            : { interactions: [interfaces_2.Interactions.ERROR], finalActions: [] })),
        authorizeParams: authorizeParams,
    };
}
function getTaxAddress(input) {
    var userGeolocation = input.userGeolocation, countryCode = input.pricingData.countryCode;
    var taxAddress;
    if (userGeolocation === null || userGeolocation === void 0 ? void 0 : userGeolocation.countryCode) {
        taxAddress = {
            country: userGeolocation.countryCode,
            city: userGeolocation === null || userGeolocation === void 0 ? void 0 : userGeolocation.city,
            state: userGeolocation === null || userGeolocation === void 0 ? void 0 : userGeolocation.region,
            postalCode: userGeolocation === null || userGeolocation === void 0 ? void 0 : userGeolocation.postalCode,
        };
    }
    else {
        taxAddress = {
            country: countryCode || "US",
        };
    }
    return taxAddress;
}
/**
 * determineNextInteractionRequest: Determine bff nextInteraction request data
 * @param input
 * @returns
 */
function determineNextInteractionRequest(input) {
    var _a, _b, _c, _d, _e, _f, _g;
    var userGeolocation = input.userGeolocation, authorizeParams = input.authorizeParams;
    var orderData = input.pricingData.eligibility.order;
    var pricingData = input.pricingData.eligibility.price;
    var taxAddress = getTaxAddress(input);
    var commandsNeeded = determineApiCommandsNeeded(input, true);
    var commandString = commandsNeeded.join(",");
    var request = (0, index_2.processBFFDataRequested)(commandString);
    var dataRequested = request.dataRequested;
    var operationName = interfaces_2.GraphQLOperations.GET_AUTH_STATE;
    var mopId = (_a = orderData === null || orderData === void 0 ? void 0 : orderData.paymentMethod) === null || _a === void 0 ? void 0 : _a.id;
    var orderUuid = (_b = orderData === null || orderData === void 0 ? void 0 : orderData.lineItem) === null || _b === void 0 ? void 0 : _b.orderUuid;
    var lineId = (_c = orderData === null || orderData === void 0 ? void 0 : orderData.lineItem) === null || _c === void 0 ? void 0 : _c.id;
    var orderStatus = (_d = orderData === null || orderData === void 0 ? void 0 : orderData.lineItem) === null || _d === void 0 ? void 0 : _d.status;
    var itemType = (_e = orderData === null || orderData === void 0 ? void 0 : orderData.lineItem) === null || _e === void 0 ? void 0 : _e.itemType;
    var billing = taxAddress;
    var currency = pricingData === null || pricingData === void 0 ? void 0 : pricingData.currency;
    var taxProductClass = pricingData === null || pricingData === void 0 ? void 0 : pricingData.itemDetails.taxProductClass;
    var price = pricingData === null || pricingData === void 0 ? void 0 : pricingData.price;
    var inApp = (_f = orderData === null || orderData === void 0 ? void 0 : orderData.mopDetails) === null || _f === void 0 ? void 0 : _f.inApp;
    var active = (_g = orderData === null || orderData === void 0 ? void 0 : orderData.mopDetails) === null || _g === void 0 ? void 0 : _g.active;
    var finalActions = input.pricingData.eligibility.finalActions;
    if (dataRequested.includes("orderDetails")) {
        operationName = interfaces_2.GraphQLOperations.GET_ORDER_DETAILS;
        request = {
            dataRequested: dataRequested,
            input: {
                lineId: lineId,
                orderStatus: orderStatus,
                itemType: itemType,
                desiredOrderStatuses: request.desiredOrderStatuses,
            },
        };
    }
    else if (dataRequested.includes("mopDetails")) {
        operationName = interfaces_2.GraphQLOperations.GET_MOP_DETAILS;
        request = {
            dataRequested: request.dataRequested,
            input: { mopId: mopId },
        };
    }
    else if (dataRequested.includes("tax")) {
        operationName = interfaces_2.GraphQLOperations.GET_TAX_QUOTE;
        request = {
            dataRequested: dataRequested,
            input: {
                billing: billing,
                currency: currency,
                taxProductClass: taxProductClass,
                price: price,
            },
        };
    }
    else {
        request = { dataRequested: dataRequested };
    }
    return {
        operationName: commandsNeeded.length == 0 ? interfaces_2.GraphQLOperations.NONE : operationName,
        request: request,
        userGeolocation: userGeolocation || {
            countryCode: taxAddress.country,
        },
        nextInteractionRequest: {
            interactions: input.interactions,
            mopId: mopId,
            orderUuid: orderUuid,
            lineId: lineId,
            orderStatus: orderStatus,
            itemType: itemType,
            inApp: inApp,
            active: active,
            finalActions: finalActions,
        },
        authorizeParams: authorizeParams,
    };
}
/**
 * nextInteractionRequestDataTransformer transform data for bff nextInteraction response
 * @param responseParams
 * @returns
 */
function nextInteractionRequestDataTransformer(responseParams) {
    return responseParams.then(function (result) {
        var _a = result.data, getAuthState = _a.getAuthState, getOrderDetails = _a.getOrderDetails, getMopDetails = _a.getMopDetails, getTaxQuote = _a.getTaxQuote;
        return {
            data: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, getAuthState), (getOrderDetails && { orderDetails: getOrderDetails })), ((getMopDetails && { mopDetails: getMopDetails }) ||
                ((getOrderDetails === null || getOrderDetails === void 0 ? void 0 : getOrderDetails.mopDetails) && {
                    mopDetails: getOrderDetails.mopDetails,
                }))), (getTaxQuote && { taxInfo: getTaxQuote })),
            errors: null,
            success: true,
        };
    });
}
function nextInteractionCommand(nextInteractionRequest, result) {
    var _a;
    var inputData = tslib_1.__assign(tslib_1.__assign({}, nextInteractionRequest), (_a = result.data) === null || _a === void 0 ? void 0 : _a.mopDetails);
    var finalActions = inputData.finalActions, orderStatus = inputData.orderStatus, interactions = inputData.interactions, paymentAccountType = inputData.paymentAccountType, itemType = inputData.itemType;
    var isOrderManagement = (0, index_2.isOrderManagementAction)(finalActions);
    var isPrevOrder = ["cancelled"].includes(orderStatus) ||
        (itemType && itemType.toLowerCase() === "subscription");
    var isSwapAction = finalActions.includes("UPGRADE") || finalActions.includes("DOWNGRADE");
    var reason = (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.toUpperCase()) || "NO_PREV_ORDER";
    var interaction = isOrderPlacement(finalActions) &&
        (interactions.includes(interfaces_2.Interactions.DEFAULT_CHECKOUT.toString()) ||
            interactions.includes(interfaces_2.Interactions.OTHER.toString()))
        ? interfaces_2.Interactions.DEFAULT_CHECKOUT.toString()
        : interfaces_2.Interactions.ERROR.toString();
    if (interactions.length > 0 &&
        (interactions.includes(interfaces_2.Interactions.DCO_1_CLICK) ||
            interactions.includes(interfaces_2.Interactions.DCO_1_CLICK_NO_PRIOR_ORDER)) &&
        (isOrderManagement ||
            isPrevOrder ||
            interactions.includes("1CLICK_NO_PRIOR_ORDER") ||
            isSwapAction)) {
        interaction = interactions.includes(interfaces_2.Interactions.DCO_1_CLICK_NO_PRIOR_ORDER.toString())
            ? interfaces_2.Interactions.DCO_1_CLICK_NO_PRIOR_ORDER.toString()
            : interfaces_2.Interactions.DCO_1_CLICK.toString();
        reason = orderStatus || "NO_PREV_ORDER";
    }
    return {
        data: {
            interaction: interaction,
            reason: reason,
            mopType: paymentAccountType,
        },
        error: null,
        message: null,
    };
}
var isOrderPlacement = function (finalActions) {
    return (finalActions.filter(function (actionName) {
        return ["JOIN", "RESUBSCRIBE", "UPGRADE", "DOWNGRADE"].includes(actionName);
    }).length > 0);
};
// exported for unittest purposes
function determineApiCommandsNeeded(input, bff) {
    var _a, _b;
    var commandsNeeded = [];
    var finalAction = input.finalAction, _c = input.pricingData, _d = _c.eligibility, order = _d.order, eligibilityFinalActions = _d.finalActions, eligibilityPrice = _d.price, taxInfo = _c.taxInfo, price = _c.price;
    var finalActions = (finalAction && [finalAction]) || eligibilityFinalActions || [];
    if (finalActions.length == 0 ||
        !input.interactions.some(function (interaction) {
            return [
                interfaces_2.Interactions.DCO_1_CLICK,
                interfaces_2.Interactions.DCO_1_CLICK_NO_PRIOR_ORDER,
            ].includes(interaction);
        })) {
        return []; // We only need extra details for DCO 1_click
    }
    commandsNeeded.push(interfaces_1.CdaCommands.GET_AUTH_STATE);
    if (order && (0, index_2.isOrderManagementAction)(finalActions)) {
        /* istanbul ignore next */
        var orderStatus = (_a = order === null || order === void 0 ? void 0 : order.lineItem) === null || _a === void 0 ? void 0 : _a.status;
        /* istanbul ignore next */
        if (orderStatus == interfaces_2.OrderStates.PENDING_CANCEL ||
            orderStatus == interfaces_2.OrderStates.PENDING_PAUSE ||
            orderStatus == interfaces_2.OrderStates.PAUSED) {
            // already tested
            /* istanbul ignore next */
            if (!order.details && !((_b = order.lineItem) === null || _b === void 0 ? void 0 : _b.details)) {
                commandsNeeded.push(interfaces_1.CdaCommands.ORDER_DETAILS_PAUSED_PENDINGPAUSE_PENDINGCANCEL);
            }
            if (!order.mopDetails) {
                commandsNeeded.push(interfaces_1.CdaCommands.MOP_DETAILS);
            }
        }
    }
    else if (!taxInfo && (eligibilityPrice || price)) {
        commandsNeeded.push(interfaces_1.CdaCommands.GET_TAX_INFO);
    }
    return commandsNeeded;
}
exports.determineApiCommandsNeeded = determineApiCommandsNeeded;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/nextInteractionApi/bff/index.js
// module id = 3411
// module chunks = 11